export const homeDataOne = {
  lightBg: "dark",
  lightText2: false,
  lightTextDesc: false,
  heading: true,
  button: true,
  description:
    "Our matching process is designed to be adaptable and flexible, allowing us to create a customised process for each of our clients.",
  imgStart: "",
  img1: "images/test2.jpg",
  img2: "images/test3.jpg",
  alt: "christina",
  noDisplay: true,
  floatImg: true,
  imgFloat1: "images/ellipse-image2.png",
  imgFloat2: "images/ellipse-image3.png",
  imgFloat3: "images/ellipse-image1.png",
  imgDouble: true,
  extraText: "top",
  extraTextValue: "Quality candidates for Quality companies",
  buttonColorOne: "white",
  buttonColorTwo: "green",
  buttonTextOne: "Hire a talent",
  buttonTextTwo: "Become a talent",
  displayButtonOne: true,
  displayButtonTwo: true,
};

export const homeDataTwo = {
  id: "pricing",
  lightBg: "",
  imgStart: "start",
  lightText: true,
  lightText2: false,
  lightTextDesc: true,
  heading: false,
  button: true,
  subHeadline: "Talentpoel is Cost-Effective",
  description:
    "Talentpoel is a low-cost solution for businesses looking to hire the best non-technical talent in Africa. Our pricing model is clear, and there are no hidden fees. We provide a variety of talent to fit a variety of budgets, and we collaborate closely with our clients to provide tailored solutions that meet their needs.",
  img1: "images/imageThree.svg",
  alt: "christina-sits",
  imgDouble: false,
  extraText: "middle",
  extraTextValue: "Matching African talent to a Global Audience",
  buttonColorOne: "green",
  buttonTextOne: "Build your non-technical team →",
  displayButtonOne: true,
  displayButtonTwo: false,
};

export const homeDataThree = {
  lightBg: "grey",
  imgStart: "",
  lightText: true,
  lightText2: false,
  lightTextDesc: true,
  heading: false,
  button: false,
  subHeadline: "Our vetting process for Talentpoel",
  description:
    "Attracting and retaining top talent is paramount for the success of any organization. However, merely having a large pool of candidates is not sufficient. The true value lies in identifying the most exceptional individuals who align with our client's unique company culture and have the potential to make meaningful contributions to its success. This is where TalentPoel’s rigorous vetting process comes into play. By employing meticulous screening and assessment methods, we ensure that we deliver the crème de la crème of talent to our clients, providing them with the best possible candidates to meet their needs and drive their organization forward.",
  img1: "images/imageFour.svg",
  alt: "sitting-girl",
  noDisplay: true,
  imgDouble: false,
  extraText: false,
  listItem: true,
};

export const homeDataFour = {
  lightBg: "grey",
  imgStart: "start",
  lightText: true,
  lightText2: false,
  lightTextDesc: true,
  heading: false,
  button: false,
  topLine: "Cultural Add Interview",
  description:
    "At our organization, we believe that cultural add is a key aspect of successful talent acquisition. It's not just about finding candidates who fit in, but also those who bring unique perspectives, diverse experiences, and complementary qualities that can enhance our client's work culture. To thoroughly assess cultural fit, we delve into the candidate's personality, work style, and interests through thoughtful questioning during our assessment process. This enables us to gauge whether the candidate's values, attitudes, and behaviors align with our client's organization and team dynamics. By prioritizing cultural add, we aim to create a cohesive and inclusive work environment that fosters collaboration, innovation, and mutual growth for both the candidate and our client's organization.",
  img1: "images/imageFive.svg",
  alt: "kojo",
  noDisplay: true,
  imgDouble: false,
  extraText: false,
};

export const homeDataFive = {
  lightBg: "grey",
  imgStart: "",
  lightText: true,
  lightText2: false,
  lightTextDesc: true,
  heading: false,
  button: false,
  topLine: "Non-Technical Interview",
  description:
    "Once we have assessed cultural fit, we evaluate candidates' skills by having them complete a skills assessment. Our assessment process includes a real-life video interview that utilises AI technology.",
  img1: "images/imageSix.svg",
  alt: "herve",
  noDisplay: true,
  imgDouble: false,
  extraText: false,
};

export const homeDataSix = {
  lightBg: "grey",
  imgStart: "start",
  lightText: true,
  lightText2: false,
  lightTextDesc: true,
  heading: false,
  button: false,
  topLine: "Personality test + Interview with a Team Member",
  description:
    "The personality test is designed to help us understand your strengths and areas for improvement, and to identify how you can best contribute to our team. The interview with a team member will give you the opportunity to learn more about our company culture, values, and goals, and to ask any questions you may have about the position and the company.",
  img1: "images/imageSeven.svg",
  alt: "christina-glasses",
  noDisplay: true,
  imgDouble: false,
  extraText: false,
};

export const homeButtonData = {
  type: "submit",
  buttonColor: "green",
  buttonSize: "btn--center",
  text: "Join the pool →",
  display: true,
};

export const bottomSectionOne = {
  lightBg: "top",
  headLine: "There’s a whole world out here.",
  headLine2: "We focus on Quality over quantity",
  lightTextDesc: true,
  lightText: true,
  description:
    "When we say we have the best talent, we mean it. Our rigorous talent acceptance process allows us to select the top 2% out of numerous applicants every quarter. These individuals are then added to our pre-vetted community of technical talent, where they undergo further training and mentorship to enhance their skills in their respective fields.",
  imgShow: "grid",
  img: "images/imageSix.svg",
  alt: "bottom-image",
  button: true,
  buttonColor: "white",
  buttonStyle: "btn--outline",
  buttonText: "Hire a talent",
  displayButton: true,
};

export const aboutData = {
  id: "about",
  lightBg: "",
  imgStart: "",
  lightText: true,
  lightText2: false,
  lightTextDesc: true,
  heading: false,
  button: true,
  smallHeadline: "About Us",
  about: true,
  aboutText: true,
  about1: `Derived from the Afrikaans word "Talentpoel", which roughly translates to Talentpool.`,
  about2:
    "Talentpoel matches vetted non-technical Mid-level/Senior level experts in Africa to global tech companies and startups. Our aim is to enable companies to have access to a broader pool of candidates regardless of location or governmental restrictions.",
  about3:
    "Our vision is to become the leading global platform for working with and hiring non-technical talent in Africa.",
  img1: "images/aboutImage.svg",
  alt: "about-image",
  noDisplay: true,
  imgDouble: false,
  extraText: "bottom",
  extraTextValue: "Our talent community is a vibrant ecosystem",
  extraTextValueTwo: "Continuous learning, diversity and collaboration",
};

export const bottomSectionTwo = {
  lightBg: "darker",
  headLine: "",
  topLine: "Meet the team ",
  lightTextDesc: false,
  lightText: false,
  description:
    "Our team has a combined experience of 20 years, hiring/working with African talents.",
  imgShow: "row",
  button: false,
  displayButton: false,
};

export const bottomSectionThree = {
  id: "talents",
  paraId: "para",
  lightBg: "",
  headLine: "Talents Available",
  topLine: "For individuals",
  lightTextDesc: true,
  lightText: false,
  description:
    "Still can't find the talent you're looking for “in the list above” click the button below  to request talent.",
  gridText: true,
  imgShow: "",
  button: true,
  buttonColor: "white",
  buttonStyle: "btn--outline",
  buttonText: "Hire a talent →",
  displayButton: true,
};


export const awardsSection = {
  id: "awards",
  lightBg: "",
  smallHeadline: "Awards & Recognition",
  awards: [
    {
      id: 1,
      img: 'images/awards/award_1.png',
      brandName: 'images/awards/award_brand_1.png',
      linkText: 'Leading Trailblazer in Africa Tech Recruitment 2024',
      linkUrl: 'https://www.ceo-review.com/winners/talentpoel/'
    },
    {
      id: 2,
      img: 'images/awards/award_2.png',
      brandName: 'images/awards/award_brand_2.png',
      linkText: 'Emerging Culture Creators 2025',
      linkUrl: 'https://www.cultureamp.com/blog/emerging-culture-creators-2025'
    },
    {
      id: 3,
      img: 'images/awards/award_3.png',
      brandName: 'images/awards/award_brand_3.png',
      linkText: 'Awarded in the MEA Business Awards 2025.',
      linkUrl: 'https://meamarkets.digital/winners/talentpoel/'
    },
  ]
}
